import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { BASE_PATH } from './variables';
import { SharedService } from './shared.service';
import { retry } from 'rxjs/operators';

@Injectable()
export class AppHttpService {
  private APIURL;
  private lotterySrc;

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    @Optional()
    @Inject(BASE_PATH)
    basePath: string
  ) {
    this.lotterySrc = this.sharedService.getLotterySource() || 'main';

    if (basePath) {
      this.APIURL = basePath;
    }
  }

  getLotteries(): Observable<any> {
    return this.http.get(this.APIURL + '/lotteries/' + this.lotterySrc);
  }

  getStaticContent(contentType): Observable<any> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'text/html; charset=utf-8'
    );
    return this.http.get(this.APIURL + '/legals/' + contentType, {
      headers,
      responseType: 'text'
    });
  }

  getPaymentMethods(landingPageId: string) {
    return this.http.get(this.APIURL + '/landingpages/' + landingPageId);
  }

  validate(type, value): Observable<any> {
    return this.http.get(
      this.APIURL + '/validate/' + type + '?' + type + '=' + value
    );
  }

  validatePhone(value): Observable<any> {
    return this.http.get(
      this.APIURL + '/validate/phonenumber?phoneNumber=' + value
    );
  }

  checkExistingEmail(email): Observable<any> {
    return this.http.post(this.APIURL + '/email/check', { email });
  }

  validateCoupon(couponData): Observable<any> {
    return this.http
      .post(this.APIURL + '/validate/coupon', couponData)
      .pipe(retry(4));
  }

  validateBankAccount(account, bank): Observable<any> {
    return this.http.get(
      this.APIURL +
        '/validate/bankaccount?accountNumber=' +
        account +
        '&bankCode=' +
        bank
    );
  }

  validateAfterPay(productsData): Observable<any> {
    return this.http.post(this.APIURL + '/validate/products', productsData);
  }

  orders(data): Observable<any> {
    return this.http.post(this.APIURL + '/orders', data);
  }

  /**
   * USER V2
   */
  getMe(): Observable<any> {
    return this.http.get(this.APIURL + '/me');
  }
}
